module.exports = __webpack_public_path__ + "media/icons/register@2x-890e2ba5.png";